import type { NullableValues } from '../../utils'

import type { CybusDetailedService, CybusServiceForm, CybusServiceParameters, CybusServiceSchema } from '../../domain'

export type ServiceManagementRequest = Readonly<{
    id: CybusDetailedService['id']
    commissioningFile: string
    parameters: CybusDetailedService['parameters']
}>

export enum ServiceManagementMode {
    CREATION = 'CREATION',
    UPDATE = 'UPDATE',
}

export type ServiceValidationArgs = Readonly<{
    schema: CybusServiceSchema
    id: CybusDetailedService['id']
    parameters: CybusDetailedService['parameters']
}>

export interface ConnectwareServicesService {
    /**
     * Receives the content of a yaml file as string, and yields a Promise of the json schema and initial values (null parameters if there is no default)
     *
     * @param fileContent the content of the file, plain text, no encoding
     * @param mode if the parsed output will be used for creation or update of an existing service, additional fields will be present in creation mode
     * @throws {import('../../domain').ConnectwareError}
     */
    parseCommissioningFile(
        fileContent: string,
        mode: ServiceManagementMode
    ): Promise<[schema: CybusServiceSchema, id: CybusServiceForm['id'], parameters: NullableValues<CybusServiceParameters>]>

    /**
     * @throws never
     */
    validate(args: ServiceValidationArgs, mode: ServiceManagementMode): boolean

    /**
     * @throws {import('../../domain').ConnectwareError}
     */
    manage(request: ServiceManagementRequest, mode: ServiceManagementMode): Promise<void>

    /**
     * @throws {import('../../domain').ConnectwareError}
     * @returns the raw service commissioning file content
     */
    fetchCommissioningFile(id: CybusDetailedService['id']): Promise<string>
}
